import { Navigate } from "react-router-dom";
import { useOssAuth } from "../../context/OssAuthContext";
import OssSectionPageHeader from "../../components/oss/OssSectionPageHeader";
import OrdiniProdotti from "../deblistering/ricette/OrdiniProdotti";

export default function OssOrdiniFarmacia() {
  const { token, activeOss } = useOssAuth();
  if (!activeOss?.responsabile) {
    return <Navigate to="/oss" replace />;
  }

  return (
    <div className="max-w-6xl mx-auto space-y-1">
      <OssSectionPageHeader
        sectionKey="ordiniFarmacia"
        title="Ordini farmacia"
        subtitle="Catalogo e ordini extra blister alla farmacia collegata"
      />
      <OrdiniProdotti token={token} apiBase="/api/oss/me/ordini-farmacia" />
    </div>
  );
}
